<script>
  import { format } from 'svelte-i18n';
  import { endOfDay, isWithinInterval, startOfDay } from 'date-fns';

  import { Table } from '@client/components/table';

  import { PUSH_ACTION_TYPES } from '@client/enums';

  import DateCell from './date-cell.svelte';
  import EmailCell from './email-cell.svelte';

  export let endDate = new Date();
  export let history = [];
  export let loading = false;
  export let size;
  export let startDate = new Date();
  export let showFilters = false;

  let columns = [
    {
      key: 'action',
      title: $format('label.PUSH_TO'),
      value: ({ action }) => $format(PUSH_ACTION_TYPES[action]) || action,
      columnClass: 'text-nowrap max-w-80',
      sortable: true
    },
    {
      key: 'user',
      title: $format('label.USER'),
      value: ({ user }) => user,
      columnClass: 'hide--mobile',
      renderComponent: {
        component: EmailCell,
        props: {
          user: ({ user }) => user,
          size: () => size
        }
      },
      sortable: true
    },
    {
      key: 'timestamp',
      title: $format('label.DATE'),
      value: ({ timestamp }) => timestamp,
      columnClass: 'max-w-140 hide--mobile',
      renderComponent: {
        component: DateCell,
        props: {
          size: () => size,
          timestamp: ({ timestamp }) => timestamp
        }
      },
      sortable: true
    },
    {
      key: 'note.emails.length',
      title: $format('label.USERS'),
      value: ({ note }) => note?.emails?.length || 1,
      sortable: true,
      columnClass: 'max-w-20 hide--tablet'
    }
  ];

  const ensureArray = (value) => (Array.isArray(value) ? value : []);

  $: visibleHistory =
    ensureArray(history) && startDate && endDate
      ? ensureArray(history).filter(({ timestamp }) => {
          const date = new Date(timestamp);

          return isWithinInterval(date, { start: startOfDay(new Date(startDate)), end: endOfDay(new Date(endDate)) });
        })
      : [];

  $: emptyLabel = ensureArray(history).length
    ? $format('label.PUSH_HISTORY_EMPTY')
    : $format('label.PUSH_HISTORY_NO_MATCHES');
</script>

{#if !loading}
  <div id="push-history-table" class:filters={showFilters}>
    <Table id="push-history-table" bind:columns rows={visibleHistory} sortBy="timestamp" sortOrder={-1} {emptyLabel} />
  </div>
{/if}

<style lang="scss">
  :global(#push-history-table .sticky-header) {
    background-color: var(--color-white);
    box-shadow: 0 1px 0 var(--border-color);
    position: sticky;
    top: 56px;
    z-index: 20;
  }

  @media only screen and (max-width: 600px) {
    :global(#push-history-table .sticky-header) {
      top: 40px;
    }

    :global(#push-history-table.filters .sticky-header) {
      top: 180px;
    }
  }
</style>
